module.exports = __webpack_public_path__ + "img/liaison_short.19a85f61.png";